import React, { useState, useEffect } from 'react'
import "../../assets/css/selectcollege.css";
import { Pagination } from "@mui/material";
import no_colleges from "../../assets/images/no_colleges.png";
import axios from 'axios';
import configModule from '../../../config.js';
import SvgContent from '../../components/Svgcontent.jsx';
import { toast, ToastContainer } from "react-toastify";

function SelectCollege({ data , onCloseHandlerSel , sendData }) {
    const [colleges, setColleges] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const config = configModule.config();
    const [search, setSearch] = useState("");
    const itemsPerPage = 25;
    const [selectedCollege, setSelectedCollege] = useState(null);
    const [selectedCollegeData, setSelectedCollegeData] = useState(null);

    const { collImageFirst, collImageSec } = data;

    const getCollegeData = async (pageNumber = 1) => {

        const params = {
            page: pageNumber,
            limit: itemsPerPage,
            search: search || ""
        };

        try {
            const res = await axios.get(
                `${config.apiBaseUrl}/get-colleges`,
                {
                    params: params,
                    headers: {
                        "x-api-key": config?.apichKey
                    },
                }
            );

            const { data, total } = res?.data || {};

            setColleges(data || []);
            setTotal(total || 0);

        } catch (err) {
            console.error("API Error:", err);

            if (err.response) {
                toast.error(err.response.data?.message || "Server error");
            } else if (err.request) {
                toast.error("No response from server");
            } else {
                toast.error("Request failed");
            }

        }

    };

    useEffect(() => {
        getCollegeData(page);
    }, [page, search]);

    const filteredColleges = [...colleges]
        .filter(c => c.name.toLowerCase().includes(search.toLowerCase()));

    const count = Math.ceil(total / itemsPerPage);
    const displayedColleges = filteredColleges.slice(0, itemsPerPage);

    useEffect(() => {
        setPage(1);
    }, [search]);

    return (
        <div className="aapnow_overlay">
            <ToastContainer />
            <div className="aapnow_modal" style={{ width: "72%" }}>
                <div className='selcollpp-header-st'>
                    <h4 className='mb-0 selcollegename-st' >Select College</h4>
                </div>
                <div className='w-100 p-3 position-relative'>
                    <input
                        type="text"
                        placeholder="Search college..."
                        className='serachcolselcoll-st'
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    <div className="searchicon-stselcoll"><SvgContent svg_name="search_icon" stroke="#ababab" /></div>

                    <div className='ppcontainer-selcoll mt-4'>
                        {displayedColleges.length > 0 ? (displayedColleges.map((college, idx) => (
                            <div className="imgselcoll-stmainn h-100 mb-3" key={idx}>
                                <div className={`imgselcoll-st position-relative ${selectedCollege === idx ? 'selected' : ''} ${collImageFirst?.id === college.id || collImageSec?.id === college.id ? 'disabled' : ''}`} onClick={() => { setSelectedCollege(idx); setSelectedCollegeData(college);}} key={idx}>
                                    <img src={college.college_primary_image} className='w-100 h-100 colimgselpp-st' alt='college_primary_image' />
                                    {selectedCollege === idx && (
                                        <div className="tick-mark">✔</div>
                                    )}
                                </div>
                                <p className='mt-2 text-center collnamefoesell-st'>{college.name}</p>
                            </div>
                        ))) : (
                            <div className="w-100 position-relative d-center">
                                <img src={no_colleges} className="maxwd-100 d-flex flex-column" alt="no_colleges" />
                                <h5 className="collisthd-st d-center">No college list found</h5>
                            </div>
                        )}
                    </div>

                </div>

                <div className="coll_paginationselcoll">
                    <Pagination
                        count={count}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                        color="primary"
                    />
                </div>

                <div className='footerst-selectcol'>
                    <button className='cancelselbtn comm-selcollegebtn' onClick={()=> { setSearch("");onCloseHandlerSel();}}>
                        Cancel
                    </button>
                    <button className='okselbtn comm-selcollegebtn' onClick={()=>{setSearch("");sendData(selectedCollegeData);}}>
                        Ok
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SelectCollege
